module.exports = __webpack_public_path__ + "img/agriculture/square_icon6.81caf602.png";